export default function InfoBubble({ className, ...props }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="105"
      height="64"
      viewBox="0 0 105 64"
      fill="none"
      className={className}
      {...props}
    >
      <mask id="info-bubble-mask" fill="white">
        <path d="M93 0C99.6274 0 105 5.37258 105 12V44C105 50.6274 99.6274 56 93 56H57.5039L52.5 64L47.4961 56H12C5.37258 56 6.44277e-08 50.6274 0 44V12C5.15422e-07 5.37258 5.37258 3.62395e-08 12 0H93Z" />
      </mask>
      <path
        d="M93 0C99.6274 0 105 5.37258 105 12V44C105 50.6274 99.6274 56 93 56H57.5039L52.5 64L47.4961 56H12C5.37258 56 6.44277e-08 50.6274 0 44V12C5.15422e-07 5.37258 5.37258 3.62395e-08 12 0H93Z"
        fill="var(--color-accent-2-100)"
      />
      <path
        d="M105 12H106H105ZM105 44H106H105ZM93 56V57V56ZM57.5039 56V55H56.9499L56.6561 55.4697L57.5039 56ZM52.5 64L51.6522 64.5303L52.5 65.8857L53.3478 64.5303L52.5 64ZM47.4961 56L48.3439 55.4697L48.0501 55H47.4961V56ZM0 44H-1H0ZM0 12H-1H0ZM12 0V-1V0ZM93 0V1C99.0751 1 104 5.92487 104 12H105H106C106 4.8203 100.18 -1 93 -1V0ZM105 12H104V44H105H106V12H105ZM105 44H104C104 50.0751 99.0751 55 93 55V56V57C100.18 57 106 51.1797 106 44H105ZM93 56V55H57.5039V56V57H93V56ZM57.5039 56L56.6561 55.4697L51.6522 63.4697L52.5 64L53.3478 64.5303L58.3517 56.5303L57.5039 56ZM52.5 64L53.3478 63.4697L48.3439 55.4697L47.4961 56L46.6483 56.5303L51.6522 64.5303L52.5 64ZM47.4961 56V55H12V56V57H47.4961V56ZM12 56V55C5.92487 55 1 50.0751 1 44H0H-1C-1 51.1797 4.8203 57 12 57V56ZM0 44H1V12H0H-1V44H0ZM0 12H1C1 5.92487 5.92487 1 12 1V0V-1C4.8203 -1 -0.999999 4.8203 -1 12H0ZM12 0V1H93V0V-1H12V0Z"
        fill="var(--color-accent-2-500)"
        mask="url(#info-bubble-mask)"
      />
    </svg>
  );
}
